import React, { useEffect, useState } from 'react'

import dayjs from 'dayjs'

import { useCupons, useStudents } from '../../../../../context'
import { useWindowSize } from '../../../../../hooks/useWindowSize'
import { Cupon, Student } from '../../../../../types'
import { Spacer } from '../../../../global'
import { InlineMenu } from '../../../../InlineMenu'
import {
  AdminDebtorsBonusList,
  AdminDueBonusList,
  AdminInactiveStudentsList,
  AdminLastClassBonusList,
} from '../../../../lists'
import { SectionSubtitle } from '../../../../texts'
import { filterInactiveStudents, InactiveStudent } from '../lists/utils'

import { BonusFilterContainer } from './styles'

const BonusFilter = ({ filterOptions }: { filterOptions: string[] }) => {
  const { cupons } = useCupons()
  const { studentsList } = useStudents()
  const { isMobile } = useWindowSize()

  const [activeFilter, setActiveFilter] = useState<string | string[] | null>(
    filterOptions[0],
  )
  const [filterList, setFilterList] = useState<Cupon[]>([])
  const [filterPersonList, setFilterPersonList] = useState<Student[] | null>([])
  const [filterInactiveStudentsList, setFilterInactiveStudentsList] = useState<
    InactiveStudent[] | null
  >(null)

  const filterDueBonus = () =>
    cupons.filter((cupon) => {
      const attendance = Number(cupon.attendance) || 0
      const amountOfClasses = Number(cupon.amountOfClasses) || 0

      return (
        dayjs(cupon.dueDate).isBefore(dayjs()) ||
        attendance - amountOfClasses >= 0
      )
    })

  const filterLastClassBonus = () =>
    cupons.filter((cupon) => {
      const attendance = Number(cupon.attendance) || 0
      const amountOfClasses = Number(cupon.amountOfClasses) || 0

      return amountOfClasses - attendance === 1
    })

  const filterDebtors = () =>
    studentsList?.filter((student) => {
      const currentAmount = Number(student.currentAmountOfClasses) || 0
      const currentAttendance = Number(student.currentAttendance) || 0

      return currentAmount < currentAttendance
    }) || []

  const filterByUnpaidBonus = () =>
    cupons.filter((cupon) => cupon.payed === false)

  const filterMapping: { [key: string]: () => void } = {
    [filterOptions[0]]: () => setFilterList(filterDueBonus()),
    [filterOptions[1]]: () => setFilterList(filterLastClassBonus()),
    [filterOptions[2]]: () => {
      setFilterPersonList(filterDebtors())
      setFilterList(filterByUnpaidBonus())
    },
  }

  // Filtra según el filtro activo
  const filterBonus = (filter: string | string[] | null) => {
    setActiveFilter(filter || filterOptions[0])
    if (typeof filter === 'string') filterMapping[filter]?.()
  }

  useEffect(() => {
    filterBonus(activeFilter)

    if (activeFilter !== filterOptions[3]) {
      setFilterInactiveStudentsList(null)
    }
  }, [activeFilter, studentsList, cupons, filterOptions])

  useEffect(() => {
    const fetchInactiveStudents = async () => {
      if (studentsList) {
        const data = await filterInactiveStudents(studentsList)

        setFilterInactiveStudentsList(data)
      }
    }
    fetchInactiveStudents()
  }, [studentsList])

  return (
    <BonusFilterContainer>
      <SectionSubtitle fontSize={18} fontWeight={600} lineHeight={27}>
        Bonos
      </SectionSubtitle>
      <Spacer height={32} />
      <InlineMenu
        userType="admin"
        menuName="adminBonusMenu"
        activeFilter={activeFilter}
        setActiveFilter={(value) => filterBonus(value)}
      />
      <Spacer height={32} />
      {activeFilter && activeFilter !== filterOptions[2] && (
        <SectionSubtitle fontSize={14} fontWeight={600}>
          {activeFilter}
        </SectionSubtitle>
      )}
      <div
        style={
          activeFilter === filterOptions[2]
            ? {
                display: 'flex',
                gap: '50px',
                flexDirection: `${isMobile ? 'column' : 'row'}`,
              }
            : {}
        }
      >
        {filterList.length > 0 && (
          <div
            style={{
              width: `${isMobile ? '100%' : '650px'}`,
            }}
          >
            {activeFilter === filterOptions[2] && (
              <SectionSubtitle
                fontSize={14}
                fontWeight={600}
                children="Bonos impagos"
              />
            )}
            {activeFilter === filterOptions[0] && (
              <AdminDueBonusList bonus={filterList} />
            )}
            {activeFilter === filterOptions[1] && (
              <AdminLastClassBonusList bonus={filterList} />
            )}
            {activeFilter === filterOptions[2] && (
              <AdminDueBonusList bonus={filterList} />
            )}
          </div>
        )}
        {filterPersonList &&
          activeFilter === filterOptions[2] &&
          filterPersonList?.length > 0 && (
            <div style={{ width: `${isMobile ? '100%' : '400px'}` }}>
              <SectionSubtitle fontSize={14} fontWeight={600}>
                Alumnos deudores
              </SectionSubtitle>
              <AdminDebtorsBonusList studensList={filterPersonList} />
            </div>
          )}

        {activeFilter === filterOptions[3] && (
          <div style={{ width: `${isMobile ? '100%' : '850px'}` }}>
            <AdminInactiveStudentsList
              studensList={filterInactiveStudentsList}
            />
          </div>
        )}
      </div>
    </BonusFilterContainer>
  )
}

export default BonusFilter
